<template>
    <v-container>

        <v-row no-gutters class="mb-3">
            <v-col cols="6">
                <back-button/>
            </v-col>
            <v-col cols="6" align="right">
                <div :class="[{'bottom-button': isMobile}]">
                    <v-btn
                        @click="save"
                        color="primary" :block="isMobile"
                        class="black--text normal-btn"
                        depressed large :loading="loading">
                        {{ $t('common.save') }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
                <basic-info-stepper v-if="mode === 'BasicInfo'" @change="userData = $event"/>
                <sport-record v-if="mode === 'SportRecord'" @change="userData = $event"/>
                <place-training v-if="mode === 'PlaceTraining'" @change="userData = $event"/>
                <set-weight v-if="mode === 'SetWeight'" @change="userData = $event"/>
                <choose-objectives v-if="mode === 'ChooseObjectives'" @change="userData = $event"/>
                <choose-equipments v-if="mode === 'ChooseEquipments'" @change="userData = $event"
                                   :selected="selectEquipments"/>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>

import BasicInfoStepper from "@/components/company/BasicInfoStepper";
import SportRecord from "@/components/student/SportRecord";
import PlaceTraining from "@/components/student/PlaceTraining";
import SetWeight from "@/components/student/SetWeight";
import ChooseObjectives from "@/components/student/ChooseObjectives";
import ChooseEquipments from "@/components/student/ChooseEquipments";

import {mapState} from 'vuex'

import {db} from '@/utils/Firebase'
import BackButton from "@/components/common/BackButton";

export default {
    components: {
        BackButton,
        BasicInfoStepper,
        SportRecord,
        PlaceTraining,
        SetWeight,
        ChooseObjectives,
        ChooseEquipments,
    },
    data() {
        return {
            userData: null,
            loading: false,
        }
    },
    computed: {
        ...mapState(['equipment']),
        mode(vm = this) {
            return vm.$route.params.mode
        },
        selectEquipments(vm = this) {
            if (vm.account?.equipments?.length > 0) return vm.account.equipments
            return []
        }
    },
    methods: {
        async save() {
            const vm = this
            vm.loading = true
            let data = vm.userData

            if (vm.mode === 'PlaceTraining') vm.userData = {places: data}
            if (vm.mode === 'ChooseObjectives') vm.userData = {objectives: data}
            if (vm.mode === 'ChooseEquipments') vm.userData = {equipments: data}

            await db.collection('users').doc(vm.currentUser.uid).update(vm.userData)
            vm.loading = false
            await vm.$router.go(-1)
        }
    },
}
</script>

<style scoped>

.bottom-button {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px;
    background-color: #FFFFFF;
    border-top: 1px solid #333333;
    z-index: 6;
}

</style>